import { css } from 'styled-components';
import { getBaseTheme } from '@Themes';

export default css`
    flex: none;
    z-index: 1;
    box-shadow: ${props =>
        props.boxshadow && `0 0 1rem 0 ${getBaseTheme().colors.area.default.strokeColor}`};
    background-color: ${props =>
        props.bgcolor ? `${getBaseTheme().colors.area.default.backgroundColor}` : 'none'};
`;
